import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Tab, TabValue } from './interfaces/tab.interface';
import { SwipeAction } from './enums/swipe-action.enum';
import { MatTabChangeEvent } from '@angular/material/tabs';

/** Minimum horizontal distance (px) that counts as a swipe instead of a tap. */
const SWIPE_THRESHOLD = 40;

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabsComponent implements OnInit {
  @Input() customClass: string = '';
  @Input() tabList: Tab<TabValue>[] = [];
  @Output() onSelectTab = new EventEmitter();
  protected selectedIndex?: number;

  constructor() {}

  ngOnInit() {
    this.tabList.some((tab: Tab<TabValue>, index: number) => {
      if (tab.default === true) {
        this.selectedIndex = index;

        const selectedTab = this.tabList[index];
        this.onSelectTab.emit(selectedTab);
      }
    });
  }

  changeTab(event: MatTabChangeEvent) {
    const selectedTab = this.tabList[event.index];
    this.onSelectTab.emit(selectedTab);
  }

  private touchStartX: number | null = null;

  protected onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0]?.clientX ?? null;
  }

  protected onTouchEnd(event: TouchEvent) {
    if (this.touchStartX === null) return;

    const deltaX = (event.changedTouches[0]?.clientX ?? this.touchStartX) - this.touchStartX;
    this.touchStartX = null;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

    this.onSwipe(deltaX < 0 ? SwipeAction.Left : SwipeAction.Right);
  }

  protected onSwipe(direction: SwipeAction) {
    if (!this.tabList?.length || !this.selectedIndex) return;

    let nextIndex = this.selectedIndex;

    if (direction === SwipeAction.Left && this.selectedIndex < this.tabList.length - 1) {
      nextIndex++;
    } else if (direction === SwipeAction.Right && this.selectedIndex > 0) {
      nextIndex--;
    }

    if (this.tabList[nextIndex]?.disabled) return;

    this.selectedIndex = nextIndex;
  }

  protected readonly SwipeAction = SwipeAction;
}
